var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganizationAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.001 10C22.071 10 20.501 8.43 20.501 6.5C20.501 6.225 20.276 6 20.001 6H12.001C11.726 6 11.501 6.225 11.501 6.5C11.501 8.43 9.93098 10 8.00098 10C7.72598 10 7.50098 10.225 7.50098 10.5V18.5C7.50098 23.19 15.456 26.805 15.796 26.955C15.861 26.985 15.931 27 16.001 27C16.071 27 16.141 26.985 16.206 26.955C16.546 26.805 24.501 23.19 24.501 18.5V10.5C24.501 10.225 24.276 10 24.001 10ZM16.001 25.95C15.336 25.63 13.186 24.545 11.356 23.035C12.356 21.435 14.096 20.45 16.001 20.45C17.471 20.45 18.856 21.02 19.891 22.06C20.181 22.35 20.426 22.685 20.646 23.035C18.816 24.54 16.666 25.63 16.001 25.95ZM23.501 18.5C23.501 19.89 22.601 21.21 21.416 22.35C21.176 21.99 20.906 21.655 20.601 21.35C19.376 20.125 17.741 19.45 16.001 19.45C13.806 19.45 11.786 20.55 10.591 22.36C9.40598 21.215 8.50098 19.89 8.50098 18.5V10.97C10.586 10.74 12.241 9.08 12.471 7H19.526C19.756 9.085 21.416 10.74 23.496 10.97V18.5H23.501Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.002 14.4453C21.002 11.6903 18.757 9.44531 16.002 9.44531C13.247 9.44531 11.002 11.6903 11.002 14.4453C11.002 17.2003 13.247 19.4453 16.002 19.4453C18.757 19.4453 21.002 17.2003 21.002 14.4453ZM16.002 18.4453C13.797 18.4453 12.002 16.6503 12.002 14.4453C12.002 12.2403 13.797 10.4453 16.002 10.4453C18.207 10.4453 20.002 12.2403 20.002 14.4453C20.002 16.6503 18.207 18.4453 16.002 18.4453Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationAdmin);
export default __webpack_public_path__ + "static/media/organization-admin.01e531c2426dcf494f78ec2dbec331f9.svg";
export { ForwardRef as ReactComponent };